import { render } from "./reset-password-3.vue?vue&type=template&id=0cb45c48"
import script from "./reset-password-3.vue?vue&type=script&lang=js"
export * from "./reset-password-3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__